import { render, staticRenderFns } from "./MenuBar.vue?vue&type=template&id=df463c3e&scoped=true&"
import script from "./MenuBar.vue?vue&type=script&lang=ts&"
export * from "./MenuBar.vue?vue&type=script&lang=ts&"
import style0 from "./MenuBar.vue?vue&type=style&index=0&id=df463c3e&scoped=true&lang=scss&"
import style1 from "./MenuBar.vue?vue&type=style&index=1&id=df463c3e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df463c3e",
  null
  
)

export default component.exports